// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1YZxZ","footer":"ModalUpdate_footer__wojaS"};